"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityDeclineDto = instanceOfOrientationOpportunityDeclineDto;
exports.OrientationOpportunityDeclineDtoFromJSON = OrientationOpportunityDeclineDtoFromJSON;
exports.OrientationOpportunityDeclineDtoFromJSONTyped = OrientationOpportunityDeclineDtoFromJSONTyped;
exports.OrientationOpportunityDeclineDtoToJSON = OrientationOpportunityDeclineDtoToJSON;
exports.OrientationOpportunityDeclineDtoToJSONTyped = OrientationOpportunityDeclineDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunityDeclineDto interface.
 */
function instanceOfOrientationOpportunityDeclineDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityDeclineDtoFromJSON(json) {
    return OrientationOpportunityDeclineDtoFromJSONTyped(json, false);
}
function OrientationOpportunityDeclineDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'],
    };
}
function OrientationOpportunityDeclineDtoToJSON(json) {
    return OrientationOpportunityDeclineDtoToJSONTyped(json, false);
}
function OrientationOpportunityDeclineDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': value['reason'],
    };
}
//# sourceMappingURL=OrientationOpportunityDeclineDto.js.map